import {RateSchedule} from 'admin/accounting/rate_schedule'

/*
  Base class to encapsulate logic for the Rate Schedule card element.
  Gets inherited by RateScheduleCards and RateScheduleCardsEditor to change the 
  look and capabilities of the cards based on contenxt. 
*/
export class RateScheduleCardBase extends HTMLElement {
  constructor(rate_schedule, upgradable=false, autoGroupHasSelectedRateSchedule=false, differentCollectionSelected=false) {
    super();
    this.rateSchedule = new RateSchedule(rate_schedule)
    this.upgradable = upgradable
    this.autoGroupHasSelectedRateSchedule = autoGroupHasSelectedRateSchedule
    this.differentCollectionSelected = differentCollectionSelected
  }

  // used to shorten commonly used longer declaration to get at RateSchedule data
  rs(){
    return this.rateSchedule.data
  }

  generate_included_features() {
    let html = '<div class="includes">'
    html += '<ul>'
    this.rateSchedule.included_items().map(charge => {
      html += `<li>
      <i class="fa fa-check"></i>
      ${charge.get_formatted_included_amount()}&nbsp;
      ${charge.data.description}</li>`
    })

    html += '</ul></div>'

    return html;
  }
  
  // If this card can be clicked to select it (upgradable)
  // and if the value for autoGroupHasSelectedRateSchedule is false
  // then render "Select"
  // else render "Upgrade"
  generate_call_to_action_button() {
    let html = ''
    if (this.upgradable && ! this.isActiveRateSchedule()) {

      // if the this.rateSchedule.data.rate_schedule_group_id differs from the selected rate_schedule_group_id
      // then the buttons should show Select
      let button_title = (this.upgradable && this.autoGroupHasSelectedRateSchedule) ? "Upgrade" : "Select"
      if (this.differentCollectionSelected) {
        button_title = "Select"
      }
      
      html = `
      <button 
        data-plan-id="${this.rs().id}" 
        data-plan-name="${this.rs().rate_schedule_name}" 
        class="change-billing-plan btn btn-primary"
        title="Click to change your billing plan."
        >
        ${button_title}
      </button>`    
    }
    else if (this.isActiveRateSchedule()) {
      html = `
      <button 
        class="select_btn"
        >
        Selected
      </button>`    
    }
    else {
      html = `<div class="cta_spacer"></div>`   
    } 
    return html;
  }

  /*
    For each included charge, generate this html:
    <tr class="feature">
      <th scope="row">Local Numbers</th>
      <td colspan="1" class="right-sep">5</td>
    </tr>   
  */
  render_included_usage(template) {
    const tbody = document.createElement('tbody')

    // create the Included Usage title row if there are charges
    let tr = document.createElement('tr')
      let td = document.createElement('td')
    tr.appendChild(td)

      let th = document.createElement('th')
      th.setAttribute("colspan",1)
      th.classList.add("category")
      th.setAttribute("id","included_usage")
      th.innerText = "Included Usage"
    tr.appendChild(th)
    tbody.appendChild(tr)

    this.rateSchedule.included_items().map(charge => {
      tr = document.createElement('tr')
      tr.classList.add("feature")
        th = document.createElement('th')
        th.setAttribute('scope','row')
        th.innerText = charge.data.description

        td = document.createElement('td')
        td.setAttribute('colspan','1')
        td.classList.add('right-sep')
        td.innerText = charge.get_formatted_included_amount()
      tr.appendChild(th)
      tr.appendChild(td)
      tbody.appendChild(tr)    
    })

    const thead = template.querySelector('.pricing-table thead')
    const tbodyz = template.querySelector('.pricing-table tbody:last-child')
    let parent = tbodyz || thead
    parent.after(tbody)
  }

  render_additional_usage(template) {
    const tbody = document.createElement('tbody')

    // create the Included Usage title row if there are charges
    let tr = document.createElement('tr')
      let td = document.createElement('td')
    tr.appendChild(td)

      let th = document.createElement('th')
      th.setAttribute("colspan",1)
      th.classList.add("category")
      th.setAttribute("id","included_usage")
      th.innerText = "Additional Usage"
    tr.appendChild(th)
    tbody.appendChild(tr)

    this.rateSchedule.additional_items().map(charge => {
      tr = document.createElement('tr')
      tr.classList.add("feature")
        th = document.createElement('th')
        th.setAttribute('scope','row')
        th.innerText = charge.data.description

        td = document.createElement('td')
        td.setAttribute('colspan','1')
        td.classList.add('right-sep')
        const v = charge.get_additional_usage_price()
        td.innerText = `${numeral( v ).format('$0,0.00[00]')} each`;
      tr.appendChild(th)
      tr.appendChild(td)
      tbody.appendChild(tr)    
    })

    const thead = template.querySelector('.pricing-table thead')
    const tbodyz = template.querySelector('.pricing-table tbody:last-child')
    let parent = tbodyz || thead
    parent.after(tbody)

    const footer = document.createElement('tfoot')
    tr = document.createElement('tr')
      td = document.createElement('td')
      td.setAttribute("colspan","2")
      td.classList.add("regulatory_text")
      td.innerHTML =`
                    <span>
                      * Canadian Local Numbers are $3 per number <br/>
                      ** Federal and Regulatory Fees may apply  
                    </span>      
      `
    tr.appendChild(td)
    footer.appendChild(tr)
    parent.after(footer)

  }

  get_base_price() {
    let price = this.rateSchedule.get_base_price()
    price = numeral( price ).format('$0,0');
    return price
  }
  
  generate_modal_template() {
    let html = '';
    // this template currently resides in the BillingPlan object.
    const templateEl = document.querySelector('#additional_charges_template');
    if (! templateEl){
      return html;
    }
    const template = templateEl.content.cloneNode(true)

    const title = this.rs().rate_schedule_name;
    const price = this.get_base_price()

    const title_el = template.querySelector('.pricing-table .title')
    if (title_el) {
      title_el.textContent = title;
    }

    const price_el = template.querySelector('.pricing-table .price')
    if (price_el){
      price_el.textContent = price;
    }
    
    this.render_included_usage(template)
    this.render_additional_usage(template)

    var outer= document.createElement('div');
    outer.appendChild(template);
    return outer.innerHTML;
  }

  generate_additional_charges_template() {
    let modal_content = [];
    if (this.rs().rate_schedule_charges_attributes) {
      modal_content = this.generate_modal_template();
    }

    let html = `
      <template id="modal_template">
        <div id="modal_template_container">
          ${modal_content}
        </div>
      </template>
    `

    return html;
  }

  isActiveRateSchedule() {
    let result =  (this.rs().is_current_rate_schedule && this.rs().show_current_plan)
    return result
  }
  
  showCurrentRateSchedule() {
    return this.rs().show_current_plan
  }

  generate_additional_fees() {
    return `
      <a 
        title="Click to view details"
        class="additional_fees">
        View Details
      </a>    
    `
  }
  
  populate_inner_html_template() {
    const included_features = this.generate_included_features();
    const ctaButton = this.generate_call_to_action_button();
    const template = this.generate_additional_charges_template();
    const base_price = this.get_base_price()
    const additional_fees = this.generate_additional_fees()
    this.innerHTML = `
    <style>
      .pricing-card {
        border: solid 1px #ccc;
        border-radius: 6px;
      }
    </style>
    <div class="pricing-card-container"}>
      <div class="pricing-card ${this.isActiveRateSchedule() === true ? "current" : ""}">
        ${template}
        <h2 class="title">${this.rs().rate_schedule_name}</h2>
        <p class="description"></p>

          <div>
            <span class="price">${base_price}</span> <span class="price-interval">/ month</span>
            <span class="additional-usage" style="padding-top: 4px"><i>plus additional usage</i></span>
          </div>

          ${included_features}

        ${ctaButton}
        ${additional_fees}
      </div>
    </div>
    `  
  }  
}
